import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute'

import ValidatorsGridLayout from './containers/Grid';

export default function ValidatorLayout() {
  return <Router>
    <PrivateRoute path="/settings/validators" component={ValidatorsGridLayout} />
  </Router>
}
